import { css } from 'styled-components';

export default css`
  .label {
    text-align: center;
    margin-bottom: 20px;
  }
`;
